import React from "react";
import VideoCarousel from "../Vlog/CarouselVideo";

const Vlog = () => {
  return (
    <div className="bg-gradient-to-br from-stone-50 via-white to-green-50/20 py-16">
      <VideoCarousel
        title="Our Media Vlog"
        paragraph="Watch our latest lectures, community updates, and inspirational message updates."
      />
    </div>
  );
};

export default Vlog;
